module.exports = __webpack_public_path__ + "images/pet.34f488fa4e4b4b85177dbbdc7182985b.svg";